import React from 'react';

interface User {
  id: string;
  name: string;
  email: string;
  avatar?: string;
}

interface UserAvatarProps {
  user: User;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  showName?: boolean;
  className?: string;
}

const UserAvatar: React.FC<UserAvatarProps> = ({ 
  user, 
  size = 'sm', 
  showName = false, 
  className = '' 
}) => {
  const sizeClasses = {
    xs: 'w-4 h-4 text-xs',
    sm: 'w-6 h-6 text-xs',
    md: 'w-8 h-8 text-sm',
    lg: 'w-10 h-10 text-base',
    xl: 'w-12 h-12 text-lg'
  };

  const avatarComponent = user.avatar ? (
    <img 
      src={user.avatar} 
      alt={user.name} 
      className={`${sizeClasses[size]} rounded-full object-cover ${className}`}
    />
  ) : (
    <div className={`${sizeClasses[size]} rounded-full bg-gray-300 flex items-center justify-center ${className}`}>
      <span className={`font-medium text-gray-600 ${size === 'xs' ? 'text-xs' : size === 'sm' ? 'text-xs' : size === 'md' ? 'text-sm' : size === 'lg' ? 'text-base' : 'text-lg'}`}>
        {user.name.charAt(0).toUpperCase()}
      </span>
    </div>
  );

  if (showName) {
    return (
      <div className="flex items-center space-x-2">
        {avatarComponent}
        <span className="text-sm text-gray-900">{user.name}</span>
      </div>
    );
  }

  return avatarComponent;
};

export default UserAvatar;